import React, { useCallback, useEffect, useMemo } from 'react';
import styles from './SeoLinks.module.scss';
import Link from 'next/link';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Button from '@/components/UI/button/Button';
import { footerLinks } from './constants';
const SeoLinks = () => {
  const [open, setOpen] = React.useState<boolean>(true);
  const links = useMemo(() => [{
    title: ' ویلاهای شمال',
    items: footerLinks['ویلاهای شمال']
  }, {
    title: ' ویلاهای جنوب',
    items: footerLinks['ویلاهای جنوب']
  }, {
    title: 'ویلاهای اطراف تهران',
    items: footerLinks['ویلاهای اطراف تهران']
  }], []);
  const handleToggle = useCallback(() => {
    setOpen(!open);
  }, [open]);
  useEffect(() => {
    if (/Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.matchMedia('(max-width: 768px)').matches) {
      setOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Box className={styles['container']} data-sentry-element="Box" data-sentry-component="SeoLinks" data-sentry-source-file="SeoLinks.tsx">
      <Box className={styles['cities']} data-sentry-element="Box" data-sentry-source-file="SeoLinks.tsx">
        {links.map((item, index) => <Box className={`${styles['city-column']} ${index === 2 ? open ? styles['show'] : styles['hide'] : ''}`} key={'CITY_ITEM_' + index}>
            <Typography component={'h6'} variant={'title'}>
              {item.title}
            </Typography>
            <Box>
              {item.items?.map(link => <Link key={link.description} href={link.link} className={styles['city-item']} passHref>
                  <Typography variant={'bodyL'}>{link.description}</Typography>
                </Link>)}
            </Box>
          </Box>)}
      </Box>
      <Box className={`${styles['tags']} ${open ? styles['show'] : styles['hide']}`} data-sentry-element="Box" data-sentry-source-file="SeoLinks.tsx">
        {footerLinks['سایر']?.map(link => <Link key={link.link} href={link.link} passHref className={styles['tag-item']}>
            <Typography variant={'bodyS'} color={'neutral_800'}>
              {link.description}
            </Typography>
          </Link>)}
      </Box>
      <Button className={styles['show-more-button']} format={'text'} onClick={handleToggle} size={'small'} data-sentry-element="Button" data-sentry-source-file="SeoLinks.tsx">
        {open ? 'مشاهده کمتر' : 'مشاهده لینک های بیشتر'}
      </Button>
    </Box>;
};
export default SeoLinks;